var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('canvas',{ref:"whiteboard",staticStyle:{"border":"1px solid red","width":"1920px","height":"1080px"},attrs:{"width":"1920","height":"1080"}})}
var staticRenderFns = []

export { render, staticRenderFns }